<template>
    <div class="float-left mr-1">
        <span class="text-danger">
            <i
                class="fa fa-trash fa-lg icon-button"
                title="Excluir rateio"
                @click.stop="confirmarExcluir()"
            ></i>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        comprometimento: {
            type: Object
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir() {
            this.$swal({
                title: 'Exclusão do rateio da requisição',
                html: `Confirma a exclusão do rateio ${this.comprometimento.idComprometimento} da requisição?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.excluirRateio()
                }
            })
        },

        excluirRateio() {
            this.$emit('excluirRateio', this.comprometimento.idComprometimento)
        }
    },

    computed: {},

    created() {}
}
</script>
